export default __webpack_public_path__ + "static/media/tailored.64e0a1d0.svg";